(function () {
  const passwordField = document.getElementById("CreatePassword");

  const resolveCheckmarkByBoolean = (isSatisfied, elementId) => {
    const checkmark = document.getElementById(elementId);
    if (isSatisfied) {
      checkmark.classList.remove("invisible");
    } else {
      checkmark.classList.add("invisible");
    }
    return isSatisfied;
  };

  const resolveCheckmarkByRegex = (password, regex, elementId) => {
    return resolveCheckmarkByBoolean(password.match(regex), elementId);
  };

  const specialCharactersRegex = /.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/\-='"].*/;

  const validatePassword = (password) => {
    const satisfiedNumber = resolveCheckmarkByRegex(
      password,
      /.*[0-9].*/,
      "at-least-one-number",
    );
    const satisfiedLower = resolveCheckmarkByRegex(
      password,
      /.*[a-z].*/,
      "at-least-one-lowercase",
    );
    const satisfiedUpper = resolveCheckmarkByRegex(
      password,
      /.*[A-Z].*/,
      "at-least-one-uppercase",
    );
    const satisfiedSpecial = resolveCheckmarkByRegex(
      password,
      specialCharactersRegex,
      "at-least-one-special",
    );
    const satisfiedLength = resolveCheckmarkByBoolean(
      password.length > 7,
      "at-least-eight-characters",
    );

    if (
      satisfiedNumber &&
      satisfiedLower &&
      satisfiedUpper &&
      satisfiedSpecial &&
      satisfiedLength
    ) {
      passwordField.classList.add("isValid");
    } else {
      passwordField.classList.remove("isValid");
    }
  };

  passwordField.addEventListener("input", (event) => {
    const newPasswordValue = event.target.value;
    validatePassword(newPasswordValue);
  });

  function initShowPassword() {
    const showPasswordCheckbox = document.getElementById("show-password");
    const visiblePasswordField =
      document.querySelector("#password-container input#CreatePassword") ||
      document.getElementById("CreatePassword");
    if (!showPasswordCheckbox || !visiblePasswordField) return;

    showPasswordCheckbox.checked = visiblePasswordField.type === "text";

    function applyShowPassword() {
      const currentValue = visiblePasswordField.value;
      visiblePasswordField.type = showPasswordCheckbox.checked
        ? "text"
        : "password";
      visiblePasswordField.value = currentValue;
    }

    showPasswordCheckbox.addEventListener("change", applyShowPassword);
    showPasswordCheckbox.addEventListener("click", function () {
      setTimeout(applyShowPassword, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShowPassword);
  } else {
    initShowPassword();
  }
})();
